import React from 'react';
import { ZendeskHelpCenterUrlList } from './ZendeskHelpCenterUrlList';

export const ZendeskHelpCenterExcludedUrls = ({
  control,
  clearErrors = (..._args: any[]) => {},
}: {
  control?: any;
  clearErrors?: (...args: any[]) => void;
}) => (
  <ZendeskHelpCenterUrlList
    control={control}
    clearErrors={clearErrors}
    name={'excluded_articles'}
    title={'Excluded URLs'}
    itemLabel={'excluded URL'}
    addLabel={'Exclude specific article'}
  />
);
